import { FC, ReactNode } from 'react';

import { RevertWebImageWrapper, WebImageWrapper } from 'styles/common';

import WebImage from 'assets/home-page/web.webp';
import RevertWebImage from 'assets/home-page/revert-web.webp';

type ShowWebs = 'none' | 'left' | 'right' | 'both';

import {
  HeroSectionGradient,
  HeroSectionWrapper,
  LeftTriangle,
  RightTriangle,
} from './HeroSection.styles';
import { useIsDesktop } from 'hooks/useIsDesktop';

interface HeroSectionProps {
  background?: string;
  children: ReactNode;
  showWebs?: ShowWebs;
  isWebMobile?: boolean;
  bgImage?: string;
  gradient?: string;
}

export const HeroSection: FC<HeroSectionProps> = ({
  background = '#000000',
  children,
  showWebs = 'none',
  isWebMobile = true,
  bgImage,
  gradient,
}) => {
  const isDesktop = useIsDesktop();
  const shouldShowLeftWeb =
    (isWebMobile || isDesktop) && (showWebs === 'left' || showWebs === 'both');
  const shouldShowRightWeb =
    (isWebMobile || isDesktop) && (showWebs === 'right' || showWebs === 'both');

  return (
    <HeroSectionWrapper
      sx={{
        background,
        backgroundImage: `url(${bgImage ?? ''})`,
      }}
    >
      {gradient && <HeroSectionGradient gradient={gradient} />}

      {shouldShowLeftWeb && (
        <WebImageWrapper>
          <img src={WebImage} alt="web" />
        </WebImageWrapper>
      )}

      {shouldShowRightWeb && (
        <RevertWebImageWrapper>
          <img src={RevertWebImage} alt="revert-web" />
        </RevertWebImageWrapper>
      )}

      {children}

      <LeftTriangle />
      <RightTriangle />
    </HeroSectionWrapper>
  );
};
